export default __webpack_public_path__ + "static/ogp-3280c55231cb5b4a4230f83b1b257954.png";